import { useEffect, useState } from "react";

export const navLinks = [
  { label: "今日头条", href: "#today" },
  { label: "实时热榜", href: "#hot" },
  { label: "栏目精选", href: "#featured" },
  { label: "本周盘点", href: "#recap" },
  { label: "专题合集", href: "#collections" },
  { label: "关于本站", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

function Brand() {
  return (
    <a href="#today" className="flex items-center gap-2.5 shrink-0" aria-label="每日爆料首页">
      <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
        <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-serif text-xl font-black tracking-tight text-foreground-950">
          每日<span className="text-primary-500">爆料</span>
        </span>
        <span className="text-[10px] text-foreground-500 tracking-[0.28em] uppercase mt-1">Daily Buzz</span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/0 border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between gap-6 px-4 md:px-6 py-3">
        <Brand />

        <nav aria-label="主导航" className="hidden lg:flex items-center gap-1">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span className="hidden md:inline-flex items-center gap-1.5 text-xs text-foreground-500 mr-1">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            2026·09·09
          </span>
          <a
            href="#collections"
            className="hidden md:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            我要投稿
            <i className="ri-send-plane-line text-sm" aria-hidden="true"></i>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "收起菜单" : "展开菜单"}
            aria-expanded={open}
            className="flex h-9 w-9 items-center justify-center rounded-md text-xl text-foreground-800 hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav aria-label="移动端导航" className="mx-auto max-w-[1200px] px-4 py-3 grid gap-1 md:px-6">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}